import {
  isValid5DigitZipCode,
  isValidCanadianCity,
  isValidCity,
  isValidEmail,
  isValidIncome,
  isValidName,
  isValidPhone,
  isValidPostalCode,
  isValidStreetAddress,
  isValidZipCode,
  stripValueToOnlyHaveNumbers
} from './PatternValidation';
import {
  checkIfAgeIsBelowEighteen,
  checkIfAgeIsMoreThan100,
  checkIfDateIsValid,
  resetDateError,
  resetDayMonthYearErrors
} from './FormValidation';

function setErrorAndResetDayMonthYear(state, errorMessage) {
  state.dateOfBirth.errorMessage.hasError = true;
  state.dateOfBirth.errorMessage.value = errorMessage;
  resetDayMonthYearErrors(state);
}

export const validateAndUpdateMonth = (state) => {
  state.dateOfBirth.month.value = stripValueToOnlyHaveNumbers(state.dateOfBirth.month.value);
  state.dateOfBirth.month.value = state.dateOfBirth.month.value.substring(0, 2);
  if (!checkIfDateIsValid(state)) {
    setErrorAndResetDayMonthYear(state, 'Invalid date');
  } else if (checkIfAgeIsBelowEighteen(state)) {
    setErrorAndResetDayMonthYear(state, 'You must be 18 years of age to qualify');
  } else {
    state.dateOfBirth.month.hasError = false;
    state.dateOfBirth.month.errorMessage = '';
    resetDateError(state);
  }
};

export const validateAndUpdateDay = (state) => {
  state.dateOfBirth.day.value = stripValueToOnlyHaveNumbers(state.dateOfBirth.day.value);
  state.dateOfBirth.day.value = state.dateOfBirth.day.value.substring(0, 2);
  if (!checkIfDateIsValid(state)) {
    setErrorAndResetDayMonthYear(state, 'Invalid date');
  } else if (checkIfAgeIsBelowEighteen(state)) {
    setErrorAndResetDayMonthYear(state, 'You must be 18 years of age to qualify');
  } else {
    state.dateOfBirth.day.hasError = false;
    state.dateOfBirth.day.errorMessage = '';
    resetDateError(state);
  }
};

export const validateAndUpdateYear = (state) => {
  state.dateOfBirth.year.value = stripValueToOnlyHaveNumbers(state.dateOfBirth.year.value);
  state.dateOfBirth.year.value = state.dateOfBirth.year.value.substring(0, 4);
  if (state.dateOfBirth.year.value.length !== 4 || !checkIfDateIsValid(state) || checkIfAgeIsMoreThan100(state)) {
    setErrorAndResetDayMonthYear(state, 'Invalid date');
  } else if (checkIfAgeIsBelowEighteen(state)) {
    setErrorAndResetDayMonthYear(state, 'You must be 18 years of age to qualify');
  } else {
    state.dateOfBirth.year.hasError = false;
    state.dateOfBirth.year.errorMessage = '';
    resetDateError(state);
  }
};

export const validateAndUpdateDateOfBirth = (state) => {
  const dateOfBirth = state.dateOfBirth.value.split('/');
  state.dateOfBirth.month.value = dateOfBirth[0];
  state.dateOfBirth.day.value = dateOfBirth[1];
  state.dateOfBirth.year.value = dateOfBirth[2];

  if (
    state.dateOfBirth.year.value === undefined ||
    state.dateOfBirth.year.value.length < 4 ||
    !checkIfDateIsValid(state) ||
    checkIfAgeIsMoreThan100(state)
  ) {
    setErrorAndResetDayMonthYear(state, 'Invalid date');
  } else if (checkIfAgeIsBelowEighteen(state)) {
    setErrorAndResetDayMonthYear(state, 'You must be 18 years of age to qualify');
  } else {
    resetDayMonthYearErrors(state);
    resetDateError(state);
  }
};

export const validateAndUpdateStreetAddress = (state) => {
  if (!state.streetAddress.value || state.streetAddress.value === '') {
    state.streetAddress.hasError = true;
    state.streetAddress.errorMessage = 'Address field is required';
  } else if (!isValidStreetAddress(state.streetAddress.value, state.modalUpdateFlag)) {
    state.streetAddress.hasError = true;
    state.streetAddress.errorMessage = 'Address field contains invalid characters';
  } else if (state.streetAddress.value.length > 31) {
    state.streetAddress.hasError = true;
    state.streetAddress.errorMessage = 'Address field should be less than 32 characters';
  } else {
    state.streetAddress.hasError = false;
    state.streetAddress.errorMessage = '';
  }
};

export const validateAndUpdateApartment = (state) => {
  if (state.apartment.value.length > 8) {
    state.apartment.hasError = true;
    state.apartment.errorMessage = 'Address field should be less than 9 characters';
  } else if (
    state.apartment.value &&
    state.apartment.value.length !== 0 &&
    !isValidStreetAddress(state.apartment.value, state.modalUpdateFlag)
  ) {
    state.apartment.hasError = true;
    state.apartment.errorMessage = 'Address field contains invalid characters';
  } else {
    state.apartment.hasError = false;
    state.apartment.errorMessage = '';
  }
};

export const validateAndUpdateCity = (state) => {
  if (!state.city.value || state.city.value === '') {
    state.city.hasError = true;
    state.city.errorMessage = 'City field is required';
  } else if (state.city.value.length > 30) {
    state.city.hasError = true;
    state.city.errorMessage = 'City field should be less than 30 characters';
  } else if (state.countryCode.value === 'CAN' ? !isValidCanadianCity(state.city.value) : !isValidCity(state.city.value)) {
    state.city.hasError = true;
    state.city.errorMessage = 'City field contains invalid characters';
  } else {
    state.city.hasError = false;
    state.city.errorMessage = '';
  }
};

export const validateAndUpdateStateOrProvince = (state) => {
  if (!state.stateOrProvince.value || state.stateOrProvince.value === '') {
    state.stateOrProvince.hasError = true;
    state.stateOrProvince.errorMessage = `${state.countryCode.value === 'CAN' ? 'Province' : 'State'} field is required`;
  } else {
    state.stateOrProvince.hasError = false;
    state.stateOrProvince.errorMessage = '';
  }
};

export const validateAndUpdatePostalCode = (state) => {
  if (!state.postalCode.value || state.postalCode.value === '') {
    state.postalCode.hasError = true;
    state.postalCode.errorMessage = 'Postal Code field is required';
  } else if (state.countryCode.value === 'CAN' ? !isValidPostalCode(state.postalCode.value) : !isValidZipCode(state.postalCode.value)) {
    state.postalCode.hasError = true;
    state.postalCode.errorMessage = 'Invalid Postal Code';
  } else {
    state.postalCode.hasError = false;
    state.postalCode.errorMessage = '';
  }
};

export const validateAndUpdateIncome = (state) => {
  state.income.value = stripValueToOnlyHaveNumbers(state.income.value);
  if (!state.income.value || state.income.value === '') {
    state.income.hasError = true;
    state.income.errorMessage = 'Income is required';
  } else if (!isValidIncome(state.income.value)) {
    state.income.hasError = true;
    state.income.errorMessage = 'Income must be between $1 and $1,200,000';
    state.income.value = state.income.value.substring(0, 8);
  } else {
    state.income.hasError = false;
    state.income.errorMessage = '';
  }
};

export const validateAndUpdateEmail = (state) => {
  if (!state.email.value || state.email.value === '') {
    state.email.hasError = true;
    state.email.errorMessage = 'Email is required';
    state.email.dealerSubmissionErrorMessage = state.preferredContactMethod?.value === 'Email' ? 'Email is required' : '';
  } else if (!isValidEmail(state.email.value)) {
    state.email.hasError = true;
    state.email.errorMessage = 'Email is Invalid';
    state.email.dealerSubmissionErrorMessage = 'Email is Invalid';
  } else {
    state.email.hasError = false;
    state.email.errorMessage = '';
    state.email.dealerSubmissionErrorMessage = '';
  }
};
export const validateAndUpdateFirstName = (state) => {
  if (!state.firstName.value || state.firstName.value.length === 0) {
    state.firstName.hasError = true;
    state.firstName.errorMessage = 'First name is required';
  } else if (!isValidName(state.firstName.value)) {
    state.firstName.hasError = true;
    state.firstName.errorMessage = 'First name is invalid';
  } else if (state.firstName.value.length > 15) {
    state.firstName.hasError = true;
    state.firstName.errorMessage = 'First name must be less than or equal to 15 characters';
  } else {
    state.firstName.hasError = false;
    state.firstName.errorMessage = '';
  }
};
export const validateAndUpdatePhoneNumber = (state) => {
  if (state.phoneNumber.value === '' && state.preferredContactMethod.value === 'Phone') {
    state.phoneNumber.hasError = true;
    state.phoneNumber.errorMessage = 'Phone Number is required';
  } else if (!isValidPhone(state.phoneNumber.value)) {
    state.phoneNumber.hasError = true;
    state.phoneNumber.errorMessage = 'Phone Number is invalid';
  } else {
    state.phoneNumber.hasError = false;
    state.phoneNumber.errorMessage = '';
  }
};

export const validateAndUpdateLastName = (state) => {
  if (!state.lastName.value || state.lastName.value.length === 0) {
    state.lastName.hasError = true;
    state.lastName.errorMessage = 'Last name is required';
  } else if (!isValidName(state.lastName.value)) {
    state.lastName.hasError = true;
    state.lastName.errorMessage = 'Last name is invalid';
  } else if (state.lastName.value.length > 40) {
    state.lastName.hasError = true;
    state.lastName.errorMessage = 'Last name must be less than or equal to 40 characters';
  } else {
    state.lastName.hasError = false;
    state.lastName.errorMessage = '';
  }
};

export const validateAndUpdateDealerSearchString = (state) => {
  state.dealerSearchString.hasError = false;
  state.dealerSearchString.errorMessage = '';
  if (state.dealerSearchType.value === 'LOCATION') {
    if (
      (state.countryCode.value === 'USA' && !isValid5DigitZipCode(state.dealerSearchString.value)) ||
      (state.countryCode.value === 'CAN' && !isValidPostalCode(state.dealerSearchString.value))
    ) {
      state.dealerSearchString.hasError = true;
      state.dealerSearchString.errorMessage = `The ${
        state.countryCode.value === 'CAN' ? 'Postal' : 'ZIP'
      } code you entered is not valid. Please try again.`;
    }
  }
};

export function maskDateOfBirthOnType(dateOfBirth) {
  const maskedDOB = dateOfBirth.replace(/\D/g, '').slice(0, 10);
  if (maskedDOB.length >= 5) {
    return `${maskedDOB.slice(0, 2)}/${maskedDOB.slice(2, 4)}/${maskedDOB.slice(4, 8)}`;
  }
  if (maskedDOB.length >= 3) {
    return `${maskedDOB.slice(0, 2)}/${maskedDOB.slice(2)}`;
  }
  return maskedDOB;
}

export function maskPostalCodeOnType(postalCode) {
  const includesDash = postalCode.includes('-');
  const maskedPostalCode = postalCode.replace(' ', '').replace('-', '');
  const returnedPostalCode = preparePostalCodeWithDashes(includesDash, maskedPostalCode);

  return returnedPostalCode.toUpperCase();
}
function preparePostalCodeWithDashes(includesDash, maskedPostalCode) {
  return maskedPostalCode.length >= 4
    ? `${maskedPostalCode.slice(0, 3)}${determineWhetherToIncludeDash(includesDash)}${maskedPostalCode.slice(3, 6)}`
    : `${maskedPostalCode}${determineWhetherToIncludeDashUnderFourDigits(includesDash)}`;
}

export function determineWhetherToIncludeDash(includesDash) {
  return includesDash ? '-' : ' ';
}

export function determineWhetherToIncludeDashUnderFourDigits(includesDash) {
  return includesDash ? '-' : '';
}
